import * as tslib_1 from "tslib";
import { create } from '@wix/fedops-logger';
import { getTranslations, isWorker } from '@wix/wixstores-client-core/dist/es/src/viewer-script/utils';
import { defaultQuantity, translationPath, trackEventMetaData, PRODUCT_PAGE_APP_NAME, } from '../constants';
import { ProductService } from '../services/productService';
import { QuantityCalculator } from '../services/products/quantityCalculator';
import { userInputsFactory, inStock } from '../services/products/producUtils';
import { overrideTranslationsWithPublicData } from './productPageStore.utils';
import * as _ from 'lodash';
import { PageMap, StoresWidgetID, APP_DEFINITION_ID, STORAGE_PAGINATION_KEY, } from '@wix/wixstores-client-core/dist/es/src/constants';
import { all } from '../commons/utils';
import { PubSubManager } from '@wix/wixstores-client-core/dist/es/src/pub-sub-manager/pubSubManager';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import { isFunction } from 'util';
import { parseUrl } from '@wix/native-components-infra/dist/src/urlUtils';
import UrlParser from '@wix/wixstores-client-core/dist/es/src/url-parser';
var ProductPageStore = /** @class */ (function () {
    function ProductPageStore(styleParams, publicData, setProps, siteStore, externalId, compId, reportError, platformAPIs) {
        var _this = this;
        this.styleParams = styleParams;
        this.publicData = publicData;
        this.setProps = setProps;
        this.siteStore = siteStore;
        this.externalId = externalId;
        this.compId = compId;
        this.reportError = reportError;
        this.media = [];
        this.userInputs = userInputsFactory();
        this.isStartReported = false;
        this.onAppLoaded = function () {
            if (!isWorker() || (_this.siteStore.isInteractive() && _this.isStartReported)) {
                _this.fedopsLogger.appLoaded();
            }
        };
        this.onFocusTriggered = function () {
            _this.setProps({
                shouldFocusAddToCartButton: false,
            });
        };
        this.socialSharing = {
            onClick: function (data) {
                var socialSharingEventWithProduct = tslib_1.__assign({}, data, { productId: _this.product.id });
                return _this.siteStore.biLogger.socialButtons(socialSharingEventWithProduct);
            },
        };
        this.infoSection = {
            onActive: function (BIEvent) {
                var infoSectionEventWithProduct = tslib_1.__assign({}, BIEvent, { productId: _this.product.id });
                return _this.siteStore.biLogger.clickOnProductDetailsSf(infoSectionEventWithProduct);
            },
        };
        this.navigate = function (product) {
            _this.siteStore.storage.local.setItem(STORAGE_PAGINATION_KEY, JSON.stringify(_this.navigationContext));
            _this.siteStore.navigate({
                url: product.fullUrl,
                sectionId: PageMap.PRODUCT,
                queryParams: undefined,
                state: product.partialUrl,
            }); // tslint:disable-line no-floating-promises
        };
        this.handleUserInput = function (inputType, data, index) {
            if (data === void 0) { data = null; }
            _this.userInputs[inputType][index] = data;
            _this.updateSelections();
            _this.nextProps();
        };
        this.updateSelections = function () {
            _this.productService.options.updateSelections(_this.product, _this.userInputs.selection);
            _this.filterMedia();
        };
        this.nextProps = function (additionalProps) {
            if (additionalProps === void 0) { additionalProps = {}; }
            var nextProps = tslib_1.__assign({ quantityRange: _this.quantityRange, product: _this.product, selectedVariant: _this.productService.options.selectedVariant, userInputs: _this.userInputs }, additionalProps);
            _this.setProps(nextProps);
        };
        this.validate = function () {
            _this.nextProps({
                userInputErrors: _this.productService.validate(_this.userInputs),
            });
        };
        this.handleAddToCart = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var eventId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isInvalid()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, all(this.trackAddToCartBI(), this.trackAddToCart())];
                    case 1:
                        _a.sent();
                        eventId = this.pubSubManager.subscribe('Minicart.DidClose', function () {
                            _this.setProps({
                                shouldFocusAddToCartButton: true,
                            });
                            _this.pubSubManager.unsubscribe('Minicart.DidClose', eventId);
                        });
                        return [2 /*return*/, this.productService.addToCart(this.product, this.userInputs, this.styleParams.booleans.productPage_openMinicart)];
                }
            });
        }); };
        this.isInvalid = function () {
            var validations = _this.productService.validate(_this.userInputs);
            return Object.keys(validations).reduce(function (accValidation, currentKey) {
                var flag = validations[currentKey].some(function (value) { return value === true; });
                return accValidation || flag;
            }, false);
        };
        this.setPageMetaData = function () {
            // todo:sagi: remove if-guard after wixcode implementation is GAed
            // https://jira.wixpress.com/browse/EE-16046
            if (!isFunction(_this.siteStore.siteApis.setPageMetaData)) {
                return;
            }
            if (!_this.siteStore.isSiteMode()) {
                return;
            }
            var title = _this.product.seoTitle || _this.product.name;
            var description = _this.product.seoDescription || _this.product.description;
            var jsonLd = {
                action: undefined,
                '@context': 'https://schema.org/',
                '@type': 'Product',
                name: title,
                image: _this.product.media.map(function (m) { return m.url; }),
                description: description,
                sku: _this.product.sku,
                offers: {
                    '@type': 'Offer',
                    url: _this.productUrl,
                    priceCurrency: _this.siteStore.currency,
                    price: _this.product.comparePrice || _this.product.price,
                    availability: inStock(_this.product) ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
                },
            };
            // The promise not resolves: https://jira.wixpress.com/browse/WEED-17596
            //tslint:disable-next-line:no-floating-promises
            _this.siteStore.siteApis.setPageMetaData({
                title: { text: title },
                description: description,
                jsonLd: jsonLd,
            }, _this.compId);
        };
        this.pagePath = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var sourcePageId, path, siteStructure, page_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sourcePageId = this.siteStore.location.query.sourcePageId;
                        path = [];
                        if (!sourcePageId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.siteStore.siteApis.getSiteStructure()];
                    case 1:
                        siteStructure = _a.sent();
                        page_1 = siteStructure.pages.find(function (p) { return p.pageId === "#" + sourcePageId; });
                        if (page_1) {
                            path.push(page_1);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, path];
                }
            });
        }); };
        this.pubSubManager = new PubSubManager(this.siteStore.pubSub);
        this.productService = new ProductService(siteStore, this.pubSubManager);
        var fedopsAppName = "" + PRODUCT_PAGE_APP_NAME + (isWorker() ? '-ooi' : '');
        if (isWorker()) {
            this.fedopsLogger = create(fedopsAppName, {
                isWidgetLogger: true,
                isServerSide: this.siteStore.isSSR(),
                appId: APP_DEFINITION_ID,
                metasiteId: this.siteStore.msid,
                widgetId: StoresWidgetID.PRODUCT_PAGE,
            });
            var sessionKey = compId + "_instance";
            if (platformAPIs.storage.session.getItem(sessionKey) !== this.siteStore.instance) {
                this.fedopsLogger.appLoadStarted();
                this.isStartReported = true;
                platformAPIs.storage.session.setItem(sessionKey, this.siteStore.instance);
            }
        }
        else {
            this.fedopsLogger = create(fedopsAppName);
        }
    }
    ProductPageStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, translations, _c, product, appSettings;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.siteStore.getSectionUrl(PageMap.PRODUCT)];
                    case 1:
                        _a.sectionUrl = (_d.sent()).url;
                        return [4 /*yield*/, all(this.getProductPageTranslations(), this.getInitialData()).catch(this.reportError)];
                    case 2:
                        _b = _d.sent(), translations = _b[0], _c = _b[1], product = _c.product, appSettings = _c.appSettings;
                        if (!product) {
                            return [2 /*return*/, this.setProps(tslib_1.__assign({ emptyState: true }, this.defaultProps))];
                        }
                        this.product = product;
                        this.pagination = this.getPrevNextProducts();
                        this.media = product.media;
                        this.translations = overrideTranslationsWithPublicData(translations, this.publicData);
                        this.multilingualService = new MultilingualService(this.publicData.APP || {}, appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        this.productService.updateOptions(this.product);
                        this.setInitialUserInputs();
                        return [4 /*yield*/, all(this.setInitialProps(), this.trackViewContent())];
                    case 3:
                        _d.sent();
                        this.setPageMetaData();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductPageStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.publicData = newPublicData;
        this.styleParams = newStyleParams;
        this.translations = overrideTranslationsWithPublicData(this.translations, this.publicData);
        this.setProps({
            texts: this.getTexts(),
        });
    };
    ProductPageStore.prototype.getTexts = function () {
        var _this = this;
        return Object.keys(this.translations).reduce(function (res, key) {
            res[key] = _this.multilingualService.get(key) || _this.translations[key];
            return res;
        }, {});
    };
    ProductPageStore.prototype.setInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = [{}, this.defaultProps];
                        _b = { handleAddToCart: this.handleAddToCart, handleUserInput: this.handleUserInput, hasMultipleMedia: this.product.media.length > 1, infoSection: this.infoSection, isSSR: this.siteStore.isSSR(), onFocusTriggered: this.onFocusTriggered };
                        return [4 /*yield*/, this.pagePath()];
                    case 1:
                        props = tslib_1.__assign.apply(void 0, _a.concat([(_b.pagePath = _c.sent(), _b.pagination = this.pagination, _b.hideNavigationUrls = !this.siteStore.isSiteMode(), _b.product = this.product, _b.productUrl = this.productUrl, _b.quantityRange = this.quantityRange, _b.selectedVariant = this.productService.options.selectedVariant, _b.shouldFocusAddToCartButton = false, _b.siteUrl = this.siteStore.location.baseUrl, _b.socialSharing = this.socialSharing, _b.texts = this.getTexts(), _b.ravenUserContextOverrides = { id: this.siteStore.storeId }, _b.userInputErrors = userInputsFactory(), _b.userInputs = this.userInputs, _b.validate = this.validate, _b.navigate = this.navigate, _b.emptyState = false, _b)]));
                        this.setProps(props);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProductPageStore.prototype, "defaultProps", {
        get: function () {
            return {
                onAppLoaded: this.onAppLoaded,
                isInteractive: this.siteStore.isInteractive(),
                cssBaseUrl: this.siteStore.baseUrls.productPageBaseUrl,
            };
        },
        enumerable: true,
        configurable: true
    });
    ProductPageStore.prototype.setInitialUserInputs = function () {
        var textFieldsLength = this.product.customTextFields ? this.product.customTextFields.length : 0;
        var selection = this.product.options.reduce(function (acc, option, i) {
            var shouldPreselect = option.selections.length > 1;
            acc[i] = shouldPreselect ? null : option.selections[0];
            return acc;
        }, []);
        this.userInputs = {
            selection: selection,
            text: Array(textFieldsLength).fill(null),
            quantity: [defaultQuantity],
        };
        this.updateSelections();
    };
    ProductPageStore.prototype.getProductPageTranslations = function () {
        return getTranslations(translationPath(this.siteStore.baseUrls.productPageBaseUrl, this.siteStore.locale));
    };
    ProductPageStore.prototype.trackAddToCartBI = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventData;
            return tslib_1.__generator(this, function (_a) {
                eventData = {
                    appName: 'productPageApp',
                    hasOptions: this.userInputs.selection.length > 0,
                    productId: this.product.id,
                    productType: this.product.productType,
                    origin: 'product-page',
                    isNavigateCart: this.productService.shouldNavigateToCart(),
                    quantity: this.selectedQuantity,
                };
                return [2 /*return*/, this.siteStore.biLogger.clickOnAddToCartSf(eventData)];
            });
        });
    };
    ProductPageStore.prototype.trackAddToCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var variant, params;
            return tslib_1.__generator(this, function (_a) {
                variant = this.productService.options.selectedVariant || this.product;
                params = tslib_1.__assign({}, trackEventMetaData, { id: this.product.id, name: this.product.name, price: variant.comparePrice || variant.price, currency: this.siteStore.currency, quantity: this.selectedQuantity });
                return [2 /*return*/, this.siteStore.windowApis.trackEvent("AddToCart" /* AddToCart */, params)];
            });
        });
    };
    ProductPageStore.prototype.trackViewContent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = tslib_1.__assign({}, trackEventMetaData, { id: this.product.id, name: this.product.name, price: this.product.comparePrice || this.product.price, currency: this.siteStore.currency });
                return [2 /*return*/, this.siteStore.windowApis.trackEvent("ViewContent" /* ViewContent */, params)];
            });
        });
    };
    ProductPageStore.prototype.filterMedia = function () {
        var filteredMedia = _.flatMap(this.userInputs.selection, function (item) { return (item && item.linkedMediaItems) || []; });
        this.product.media = filteredMedia.length ? filteredMedia : this.media;
    };
    ProductPageStore.prototype.getUrlWithoutParams = function (url) {
        var parsedUrl = parseUrl(url);
        return parsedUrl.protocol + "://" + parsedUrl.host + parsedUrl.path;
    };
    ProductPageStore.prototype.getInitialData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product, appSettings, currentUrl, fetch_1, data, fetch_2, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentUrl = this.getUrlWithoutParams(this.siteStore.location.url);
                        if (!((this.siteStore.isPreviewMode() && this.siteStore.location.path.length > 1) ||
                            (this.siteStore.isSiteMode() && currentUrl !== this.sectionUrl))) return [3 /*break*/, 2];
                        fetch_1 = this.productService.getProductBySlug(this.slug, this.externalId);
                        return [4 /*yield*/, fetch_1];
                    case 1:
                        data = _a.sent();
                        product = data.catalog.product;
                        appSettings = data.appSettings;
                        return [3 /*break*/, 4];
                    case 2:
                        fetch_2 = this.productService.getDefaultProduct(this.externalId);
                        return [4 /*yield*/, fetch_2];
                    case 3:
                        data = _a.sent();
                        product = data.catalog.products.list[0];
                        appSettings = data.appSettings;
                        _a.label = 4;
                    case 4: return [2 /*return*/, { product: product, appSettings: appSettings }];
                }
            });
        });
    };
    ProductPageStore.prototype.getPrevNextProducts = function () {
        var _this = this;
        var prevProduct = {};
        var nextProduct = {};
        this.navigationContext = this.getNavigationContext();
        var paginationMap = this.navigationContext.paginationMap;
        paginationMap.forEach(function (slug, index) {
            if (slug === _this.product.urlPart) {
                if (paginationMap[index - 1]) {
                    prevProduct = {
                        partialUrl: paginationMap[index - 1],
                        fullUrl: new UrlParser(_this.sectionUrl + "/" + paginationMap[index - 1]).generate({}, _this.siteStore.location.query),
                    };
                }
                if (paginationMap[index + 1]) {
                    nextProduct = {
                        partialUrl: paginationMap[index + 1],
                        fullUrl: new UrlParser(_this.sectionUrl + "/" + paginationMap[index + 1]).generate({}, _this.siteStore.location.query),
                    };
                }
            }
        });
        this.siteStore.storage.local.removeItem(STORAGE_PAGINATION_KEY);
        return {
            nextProduct: nextProduct,
            prevProduct: prevProduct,
        };
    };
    Object.defineProperty(ProductPageStore.prototype, "slug", {
        get: function () {
            var dirtySlug = decodeURIComponent(this.siteStore.location.path[this.siteStore.location.path.length - 1]);
            return dirtySlug.split('?')[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductPageStore.prototype, "quantityRange", {
        get: function () {
            var qunatities = QuantityCalculator.getQuantitiesRange(this.product, this.userInputs.selection);
            return { max: qunatities[qunatities.length - 1], min: qunatities[0] };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductPageStore.prototype, "selectedQuantity", {
        get: function () {
            return this.userInputs.quantity[0];
        },
        enumerable: true,
        configurable: true
    });
    ProductPageStore.prototype.getNavigationContext = function () {
        var context;
        try {
            context = JSON.parse(this.siteStore.storage.local.getItem(STORAGE_PAGINATION_KEY));
        }
        catch (_a) {
            //
        }
        return context || { pageId: undefined, paginationMap: [] };
    };
    Object.defineProperty(ProductPageStore.prototype, "productUrl", {
        get: function () {
            return this.sectionUrl + "/" + this.slug;
        },
        enumerable: true,
        configurable: true
    });
    return ProductPageStore;
}());
export { ProductPageStore };
//# sourceMappingURL=productPageStore.js.map